module.exports = __webpack_public_path__ + "img/3.04.thmb.xs.34003463.jpg";